import styled from 'styled-components';

// @ts-ignore
export default styled.div(({ theme, lighter }) => ({
  borderTop: `1px solid ${lighter === true ? '#C4C4C4' : theme.palette.textColors.label}`,
  width: '100%',
}));